import {Injectable} from '@angular/core';
import {NeoRestService} from '../neo-rest/neo-rest.service';

@Injectable()
export class NeoPrivateService {

    constructor(
        private _rest: NeoRestService
    ) {}

    /**
     * Obtiene la lista de usuarios
     */
    getMessageList() {
        return this._rest.get('/messages/');
    }

    /**
     * Recarga un support
     *
     * @param support
     * @returns {Observable<any>}
     */
    reloadSupport(support) {
        return this._rest.get(`/user/support/supportname=${support}`);
    }
}



// WEBPACK FOOTER //
// ./src/app/core/services/neo-private/neo-private.service.ts